






















import { Component, Vue, Prop } from 'vue-property-decorator'
import { AddWarning } from '../store/warning'

@Component
export default class WarningForm extends Vue {
  @Prop() title!: string
  @Prop({ default: () => ({}) }) placeholder!: AddWarning

  name = this.placeholder.name || ''
  nameRules = [(v: string) => !!v || 'Name is required']

  description = this.placeholder.description || ''
  valid = false

  submit() {
    this.$emit('submit', {
      name: this.name,
      description: this.description
    })
  }
  cancel() {
    this.$emit('cancel')
  }
}
